import { HTMLAttributes } from 'react';
import FeedbackMessage from '../FeedbackMessage';

import * as S from './styles';

export interface SelectProps extends HTMLAttributes<HTMLSelectElement> {
  options: Array<[string, string]>;
  label?: string;
  required?: boolean;
  name: string;
  isValid?: boolean;
  feedbackMessage?: string;
  placeholder?: string;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

const Select = ({
  label,
  name,
  options,
  required,
  isValid,
  placeholder,
  feedbackMessage,
  variant = 'primary',
  disabled = false,
  ...props
}: SelectProps) => (
  <div>
    {label && (
      <S.Label htmlFor={name} aria-required={required} required={required}>
        {label}
      </S.Label>
    )}

    <S.Select
      variant={variant}
      component="select"
      $isValid={isValid}
      name={name}
      disabled={disabled}
      {...props}
    >
      {placeholder && (
        <option disabled selected value="">
          {placeholder}
        </option>
      )}

      {options.map(([value, text]) => (
        <option key={value} value={value}>
          {text}
        </option>
      ))}
    </S.Select>

    {!isValid && feedbackMessage && (
      <FeedbackMessage marginTop={8}>{feedbackMessage}</FeedbackMessage>
    )}
  </div>
);

export default Select;
